import * as React from 'react';

import { model, gtechurl } from '../config/config';
import Badge from '@mui/material/Badge';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { styled } from '@mui/material/styles';



const StyledBadge = styled(Badge)(({ theme }) => ({
        '& .MuiBadge-badge': {
            right: 125,
            top: 20,
            padding: '2px 8px',
            borderRadius: '6px',
            borderBottom: '6px',
        },
    }));

export default function ColorBadge(props) {
    
    return (
				<StyledBadge>
                <Card sx={{ width: 150  }}>
                    <CardActionArea sx={{ backgroundColor: "none" }}  href={`/${props.model}/latest`} 
					onClick={(evt) => {
									localStorage['model'] = props.model
									}}
					>
                        <CardMedia 
                            component="img"
                            image={ `${gtechurl}falcon/images/${props.imageNamew}.png` }
                            alt="green iguana"
							
							sx={{ p:1, height: 200,objectFit: 'contain' }}
							 
                        />
                        <CardContent sx={{ p: 1 }} title={props.name}>
                            <Typography gutterBottom variant="subtitle1" component="div" textAlign="center" noWrap={true}>
                                <span>{props.name}</span>
								
                            </Typography>
               
                        </CardContent>
                    </CardActionArea>
                </Card>
				</StyledBadge>
            
    );
}